export default __webpack_public_path__ + "static/media/blocksync.322d5a43.svg";